import DashboardLayout from '@/layout/dashboard/DashboardLayout.vue';
// GeneralViews
import NotFound from '@/pages/NotFoundPage.vue';

// Admin pages
import Dashboard from '@/pages/Dashboard.vue';
import NotAuthLayout from '../layout/NotAuth/NotAuthLayout';
import Login from '../pages/Auth/Login';
import Settings from '../pages/Settings/Settings';

import guest from './middleware/guest';
import auth from './middleware/auth';
import middlewarePipeline from './middlewarePipeline';

import checkIfCanListOfCompanies from './scopes/user_account/list/checkIfCanList';
import checkIfCanListOfUsers from './scopes/system_company/list/checkIfCanList';
import checkIfCanListOfSystemRoles from './scopes/system_roles/list/checkIfCanList';
import checkIfCanUpdateSystemRoles from './scopes/system_roles/update/checkIfCanUpdate';
import UsersShow from '../pages/Settings/users/UsersShow';
import CompanyShow from '../pages/Settings/MyOrganization/CompanyShow';
import CompanyUserShow from '../pages/Settings/MyOrganization/CompanyUserShow';
import RightsManagementIndex from '../pages/Settings/RightsManagement/RightsManagementIndex';
import SuperUserIndex from '../pages/Settings/SuperUser/SuperUserIndex';
import SuperUserCompanyShow from '../pages/Settings/SuperUser/SuperUserCompanyShow';
import EnergyPage from '../pages/Dashboard/EnergyPage';
import AirPage from '../pages/Dashboard/AirPage';
import WaterPage from '../pages/Dashboard/WaterPage';
import EnvironmentPage from '../pages/Dashboard/EnvironmentPage';
import PoliciesPage from '../pages/Dashboard/PoliciesPage';
import ConsumptionPage from '../pages/Consumption/ConsumptionPage';
import RecommendationsPage from '../pages/Dashboard/RecommendationsPage';
import PageLayout from '../layout/PageLayout';
import logout from './middleware/logout';
import RightsManagementShow from '../pages/Settings/RightsManagement/RightsManagementShow';
import SuperUserRightsManagementShow from '../pages/Settings/SuperUser/SuperUserRightsManagementShow';
import ManageAnswers from '../pages/Questions/ManageAnswers';
import ManageQuestions from '../pages/Questions/ManageQuestions';
import ManageCompanyAnswers from '../pages/Questions/ManageCompanyAnswers';
import ManageCertificates from '../pages/Certificates/ManageCertificates';
import CreateQuestion from '@/pages/Questions/CreateQuestion';
import EditQuestion from '@/pages/Questions/EditQuestion';
import Suggestions from '@/pages/Suggestions/Suggestions';
import CreateSuggestion from '@/pages/Suggestions/CreateSuggestion';
import EditSuggestion from '@/pages/Suggestions/EditSuggestion';
import checkIfCanSeeManageQuestions from '@/router/scopes/manage_questions/CheckIfCanSeeManageQuestions';
import checkIfCanCreateQuestions from '@/router/scopes/manage_questions/CheckIfCanCreateQuestions';
import checkIfCanUpdateQuestions from '@/router/scopes/manage_questions/CheckIfCanUpdateQuestions';
import checkIfCanSeeCertificates from '@/router/scopes/certificates/CheckIfCanSeeCertificates';
import checkIfCanSeeSuggestion from '@/router/scopes/suggestions/CheckIfCanSeeSuggestion';
import checkIfCanCreateSuggestion from '@/router/scopes/suggestions/CheckIfCanCreateSuggestion';
import checkIfCanUpdateSuggestion from '@/router/scopes/suggestions/CheckIfCanUpdateSuggestion';
import checkIfCanSeeQuestionnaireRoutes from '@/router/scopes/questionnaire/CheckIfCanSeeQuestionnaireRoutes';
import checkIfCanSeeManageQuestionsRoutes from '@/router/scopes/manage_questions/CheckIfCanSeeManageQuestionsRoutes';
import checkIfCanCreateQuestionsRoutes from '@/router/scopes/manage_questions/CheckIfCanCreateQuestionsRoutes';
import checkIfCanUpdateQuestionsRoutes from '@/router/scopes/manage_questions/CheckIfCanUpdateQuestionsRoutes';
import checkIfCanSeeCertificatesRoutes from '@/router/scopes/certificates/CheckIfCanSeeCertificatesRoutes';
import checkIfCanSeeSuggestionRoutes from '@/router/scopes/suggestions/CheckIfCanSeeSuggestionRoutes';
import checkIfCanCreateSuggestionRoutes from '@/router/scopes/suggestions/CheckIfCanCreateSuggestionRoutes';
import checkIfCanUpdateSuggestionRoutes from '@/router/scopes/suggestions/CheckIfCanUpdateSuggestionRoutes';
import NotificationSettings from '@/pages/Settings/Notification/NotificationSettings';
import WastePage from '@/pages/Dashboard/WastePage';
import Applications from '@/pages/Settings/Api/Applications';
import CreateApplication from '@/pages/Settings/Api/CreateApplication';
import ShowApplication from '@/pages/Settings/Api/ShowApplication';
import test from '@/pages/API/test';
import PublicDashboard from '@/pages/API/Public/Dashboard/PublicDashboard';
import PublicDataLayout from '@/layout/PublicDataLayout';
import publicAuth from '@/router/middleware/publicAuth';
import InvalidToken from '@/pages/API/Public/InvalidToken';
import ResiliencyDashboard from '@/pages/Resiliency/ResiliencyDashboard';
import Disaster from '@/pages/Resiliency/Disaster';
import MembershipEngagement from '@/pages/Resiliency/MembershipEngagement';
import Finance from '@/pages/Resiliency/Finance';
import SignUpDashboard from '@/components/Questions/SignUpDashboard';
import checkIfCanSeeCompanyQuestionnaireRoutes from '@/router/scopes/questionnaire/CheckIfCanSeeCompanyQuestionnaireRoutes';
import ElectricityConsumptionPage from '@/pages/Consumption/ElectricityConsumptionPage';
import GasConsumptionPage from '@/pages/Consumption/GasConsumptionPage';
import FuelConsumptionPage from '@/pages/Consumption/FuelConsumptionPage';
import WaterConsumptionPage from '@/pages/Consumption/WaterConsumptionPage';
import DieselConsumptionPage from '@/pages/Consumption/DieselConsumptionPage';
import Redirect from '@/pages/Consumption/Redirect';
import EnergySupplierAuthenticationPage from '@/pages/Consumption/EnergySupplierAuthenticationPage';

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    meta: {
      middleware: [auth],
    },
    children: [
      {
        path: 'sustainability/dashboard',
        name: 'sustainability dashboard',
        component: SignUpDashboard,
        meta: {
          title: 'Sustainability Dashboard',
          middleware: [auth],
        },
      },
      {
        path: 'energy',
        name: 'energy',
        component: EnergyPage,
        meta: {
          title: 'Energy',
          middleware: [auth],
        },
      },
      {
        path: 'air',
        name: 'air',
        component: AirPage,
        meta: {
          title: 'Air',
          middleware: [auth],
        },
      },
      {
        path: 'water',
        name: 'water',
        component: WaterPage,
        meta: {
          title: 'Water',
          middleware: [auth],
        },
      },
      {
        path: 'environment',
        name: 'environment',
        component: EnvironmentPage,
        meta: {
          title: 'Environment',
          middleware: [auth],
        },
      },
      {
        path: 'policies',
        name: 'policies',
        component: PoliciesPage,
        meta: {
          title: 'Policies',
          middleware: [auth],
        },
      },
      {
        path: 'waste',
        name: 'waste',
        component: WastePage,
        meta: {
          title: 'Waste',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: '/',
    component: PageLayout,
    redirect: '/settings',
    meta: {
      middleware: [auth],
    },
    children: [
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
        meta: {
          title: 'Settings',
          middleware: [auth],
        },
      },
      {
        path: '/users/:id',
        name: 'My Profile',
        component: UsersShow,
        meta: {
          title: 'My profile',
          middleware: [auth, checkIfCanListOfUsers],
        },
      },
      {
        path: '/companies/:id',
        name: 'Company Info',
        component: CompanyShow,
        meta: {
          title: 'Company Info',
          middleware: [auth, checkIfCanListOfCompanies],
        },
      },
      {
        path: '/companies/user/:id',
        name: 'User of Company',
        component: CompanyUserShow,
        meta: {
          title: 'User of Company',
          middleware: [auth, checkIfCanListOfUsers],
        },
      },
      {
        path: '/roles',
        name: 'roles',
        component: RightsManagementIndex,
        meta: {
          title: 'Roles',
          middleware: [auth, checkIfCanListOfSystemRoles],
        },
      },
      {
        path: '/roles/:id',
        name: 'Role Info',
        component: RightsManagementShow,
        meta: {
          title: 'Role Info',
          middleware: [auth, checkIfCanListOfSystemRoles],
        },
      },
      {
        path: '/super_user',
        name: 'Super user',
        component: SuperUserIndex,
        meta: {
          title: 'Super User Page',
          middleware: [auth, checkIfCanListOfCompanies],
        },
      },
      {
        path: '/super_user/company/:id',
        name: 'Super User Company Info',
        component: SuperUserCompanyShow,
        meta: {
          title: 'Company Info',
          middleware: [auth, checkIfCanListOfCompanies],
        },
      },
      {
        path: '/super_user/company/:id/role/:role_id',
        name: 'Company Role Info',
        component: SuperUserRightsManagementShow,
        meta: {
          title: 'Company Role Info',
          middleware: [auth, checkIfCanListOfCompanies],
        },
      },
      {
        path: '/manage_answers',
        name: 'Questionnaire',
        component: ManageAnswers,
        meta: {
          title: 'Questionnaire',
          middleware: [auth, checkIfCanSeeQuestionnaireRoutes],
        },
      },
      {
        path: '/manage_answers/:company_id',
        name: 'Company Questionnaire',
        component: ManageCompanyAnswers,
        meta: {
          title: 'Company Questionnaire',
          middleware: [auth, checkIfCanSeeCompanyQuestionnaireRoutes],
        },
      },
      {
        path: '/manage_questions',
        name: 'Manage Questions',
        component: ManageQuestions,
        meta: {
          title: 'Manage Questions',
          middleware: [auth, checkIfCanSeeManageQuestionsRoutes],
        },
      },
      {
        path: '/manage_questions/create_question',
        name: 'Create Question',
        component: CreateQuestion,
        meta: {
          title: 'Create Question',
          middleware: [auth, checkIfCanCreateQuestionsRoutes],
        },
      },
      {
        path: '/manage_questions/edit_question/:questionId',
        name: 'Edit Question',
        component: EditQuestion,
        meta: {
          title: 'Edit Question',
          middleware: [auth, checkIfCanUpdateQuestionsRoutes],
        },
      },
      {
        path: '/manage_certificates',
        name: 'Manage Certificates',
        component: ManageCertificates,
        meta: {
          title: 'Manage Certificates',
          middleware: [auth, checkIfCanSeeCertificatesRoutes],
        },
      },
      {
        path: '/suggestions',
        name: 'Suggestions',
        component: Suggestions,
        meta: {
          title: 'Suggestions',
          middleware: [auth, checkIfCanSeeSuggestionRoutes],
        },
      },
      {
        path: '/create_suggestion',
        name: 'Create Suggestion',
        component: CreateSuggestion,
        meta: {
          title: 'Create Suggestion',
          middleware: [auth, checkIfCanCreateSuggestionRoutes],
        },
      },
      {
        path: '/edit_suggestion/:suggestionId',
        name: 'Edit Suggestion',
        component: EditSuggestion,
        meta: {
          title: 'Edit Suggestion',
          middleware: [auth, checkIfCanUpdateSuggestionRoutes],
        },
      },
      {
        path: '/settings/notifications',
        name: 'Notification Settings',
        component: NotificationSettings,
        meta: {
          title: 'Notification Settings',
          middleware: [auth],
        },
      },
      {
        path: '/settings/applications',
        name: 'Applications',
        component: Applications,
        meta: {
          title: 'API Applications',
          middleware: [auth],
        },
      },
      {
        path: '/settings/applications/create',
        name: 'Create new Application',
        component: CreateApplication,
        meta: {
          title: 'Create API Application',
          middleware: [auth],
        },
      },
      {
        path: '/settings/application/:client_id',
        name: 'Application Info',
        component: ShowApplication,
        meta: {
          title: 'Application Info',
          middleware: [auth],
        },
      },
      {
        path: '/consumption',
        name: 'Consumption',
        component: ConsumptionPage,
        meta: {
          title: 'Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/electricity',
        name: 'electricity',
        component: ElectricityConsumptionPage,
        meta: {
          title: 'Electricity Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/gas',
        name: 'gas',
        component: GasConsumptionPage,
        meta: {
          title: 'Gas Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/fuel',
        name: 'fuel',
        component: FuelConsumptionPage,
        meta: {
          title: 'Fuel Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/diesel',
        name: 'diesel',
        component: DieselConsumptionPage,
        meta: {
          title: 'Diesel Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/water',
        name: 'water consumption',
        component: WaterConsumptionPage,
        meta: {
          title: 'Water Consumption',
          middleware: [auth],
        },
      },
      {
        path: '/consumption/auth/energy_supplier/:id',
        name: 'Supplier Authentication',
        component: EnergySupplierAuthenticationPage,
        meta: {
          title: 'Authentication',
          middleware: [auth],
        },
      },
      {
        path: '/resiliency/dashboard',
        name: 'Resiliency Dashboard',
        component: ResiliencyDashboard,
        meta: {
          title: 'Resiliency Dashboard',
          middleware: [auth],
        },
      },
      {
        path: '/resiliency/disaster',
        name: 'disaster',
        component: Disaster,
        meta: {
          title: 'Disaster',
          middleware: [auth],
        },
      },
      {
        path: '/resiliency/finance',
        name: 'finance',
        component: Finance,
        meta: {
          title: 'Finance',
          middleware: [auth],
        },
      },
      {
        path: '/resiliency/membershipEngagement',
        name: 'membership engagement',
        component: MembershipEngagement,
        meta: {
          title: 'Membership Engagement',
          middleware: [auth],
        },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: '/',
    redirect: '/login',
    component: NotAuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          title: 'Login',
          middleware: [guest],
        },
      },
      {
        path: 'logout',
        name: 'logout',
        component: Login,
        meta: {
          middleware: [auth, logout],
        },
      },
      {
        path: 'pge_redirect',
        name: 'pge_redirect',
        component: Redirect,
        // meta: {
        //   title: 'Redirect',
        //   middleware: [
        //     auth, guest
        //   ]
        // }
      },
    ],
  },
  {
    path: '/',
    redirect: '/api/public',
    component: PublicDataLayout,
    children: [
      {
        path: '/api/public/dashboard',
        name: 'Public Dashboard',
        component: PublicDashboard,
        meta: {
          title: 'Public Dashboard',
          middleware: [publicAuth],
        },
      },
      {
        path: '/api/public/invalid_token',
        name: 'Invalid Token',
        component: InvalidToken,
        meta: {
          title: 'Invalid Token',
        },
      },
      {
        path: '/api/test',
        name: 'Api Test',
        component: test,
        meta: {
          title: 'Api Test',
        },
      },
    ],
  },

  {
    path: '*',
    component: DashboardLayout,
    children: [
      {
        path: '*',
        name: 'Not Found',
        component: NotFound,
      },
    ],
  },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
